<template>
  <iframe id="questionnaireContent" :src="this.path"
          class="h-100 w-100" allowfullscreen></iframe>
</template>
<script>

import { mapGetters } from 'vuex';
import { getToken } from '@/common/jwt.service';
import store from '@/store';
import { FETCH_COURSES } from '@/store/actions.type';

export default {
  name: 'QuestionnaireViewer',

  components: {
  },
  computed: {
    path() {
      return `${process.env.VUE_APP_API_URL}/api/front/v1/player/${this.course.organization_id}/${this.currentSession.attendee}/${this.course.glue}/questionnaire/player?token=${getToken()}`;
    },
    ...mapGetters(['course', 'organization', 'currentSession']),
  },
  mounted() {
    this.terminated = false;
    this.leavePath = `${process.env.VUE_APP_API_URL}/api/front/v1/player/${this.course.organization_id}/${this.currentSession.attendee}/${this.course.glue}/questionnaire/player/leave?token=${getToken()}`;
    window.addEventListener('message', this.receiveMessage);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  watch: {
    $route() {
      this.terminated = false;
    },
  },
  beforeRouteUpdate() {
    this.terminated = false;
  },
  beforeDestroy() {
    this.handleBeforeUnload();
    window.removeEventListener('message', this.receiveMessage);
  },
  data() {
    return {
      terminated: false,
      leavePath: '',
    };
  },
  props: {
  },
  methods: {
    handleBeforeUnload() {
      navigator.sendBeacon(this.leavePath);
    },
    receiveMessage(e) {
      if (e.data === 'questionnaireCommitted') {
        store.dispatch(FETCH_COURSES).then(() => {
          this.$Progress.finish();
        });
      } else if (e.data === 'questionnaireTerminated') {
        this.terminated = true;
        store.dispatch(FETCH_COURSES).then(() => {
          this.$Progress.finish();
        });
      }
    },
  },
};
</script>
